import React, { useContext, useRef, useEffect } from 'react';
import TextInput from '../UI/TextInput';
import { ReactComponent as SearchIcon } from '../../assets/icons/search-input-icon.svg';
import classes from './index.module.scss';
import DateRange from '../UI/DateRange';
import { SearchContext } from '../../context/Search';

const FullTextSearch = ({ titleFormat }) => {
  const { active, onChangeSearchHandler, handleTimeCallback, onSubmit, currentInputValues, setCurrentInputValues } = useContext(SearchContext);
  
  const placeholderFormat = () => {
    if (active) {
      if (active === "contract_opportunities") {
        return `Search for ${titleFormat(active, '_')} by NAICS, Title, Keyword, or Set-Aside`
      } else if (active === "users") {
        return "Search by username, email, type"
      } else {
        return `Search for ${titleFormat(active, '_')}`
      }
    } else {
      return ""
    }
  }

  return (
  <form>
    <div className={classes.FullTextSearch}> 
      <div className={classes.Search_Input_Wrapper}>
        <div className={classes.Search_Input}>
         
          <TextInput
            name="search"
            type="text"
            id="search"
            placeholder={placeholderFormat()}
            onChange={onChangeSearchHandler}
            value={currentInputValues.search}
          />
          <SearchIcon />
        </div>
      </div>
      {
        active === "contract_opportunities" && (
          <DateRange 
            handleTimeCallback={handleTimeCallback}
            name="posted_date"
            id="posted_date"
            inputStyle={classes.SearchDateRange}
            wrapStyle={classes.Date_Picker_Wrap}
            cancelCallback = {() => {setCurrentInputValues({
              ...currentInputValues,
              "posted_date": {}
            })}}
            isPicked = {()=>Object.keys(currentInputValues["posted_date"]).length === 0}
          />
        ) 
      }
      <button
        className='btnSizes filledBtn px-5'
        onClick={e => onSubmit(e)}
        type="submit"
        
      >
        Search
      </button>
   
    </div>
  </form>
  )
}

export default FullTextSearch;